module.exports = __webpack_public_path__ + "static/img/swimming.11b6ec7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swimming.png
// module id = QOCK
// module chunks = 20